import { Grid } from "@mui/material";
import ModListBox from "./ModListBox";
import { useEffect, useState } from "react";

function MapModList({ searchWord, result, setResult, engResult, setEngResult, show17Mod, version }) {
  const [allMods, setAllMods] = useState([]);
  const [selected, setSelected] = useState([]);
  const [ignoreSelected, setIgnoreSelected] = useState([]);

  useEffect(() => {
    // Promise.all을 사용하여 여러 파일을 동시에 가져옴
    Promise.all([
      import(`../MapOptionData/${version}/mapModPrefix`),
      import(`../MapOptionData/${version}/mapModSuffix`)
    ])
      .then(([prefixModule, suffixModule]) => {
        // 접두어/접미어를 하나의 목록으로 합침. no가 양쪽에서 1부터 겹치므로 합성 id로 구분
        const prefix = (prefixModule.default || []).map((data) => ({ ...data, id: `p-${data.no}` }));
        const suffix = (suffixModule.default || []).map((data) => ({ ...data, id: `s-${data.no}` }));
        setAllMods([...prefix, ...suffix]);
      })
      .catch((error) => {
        console.error("Failed to load mapMod files:", error);
        setAllMods([]);
      });
  }, [version]); // version이 변경될 때마다 실행

  useEffect(() => {
    if (result.wantMod.length === 0 && result.ignoreMod.length === 0) {
      setSelected([]);
      setIgnoreSelected([]);
      return;
    }
    // allMods는 비동기 로드됨. 저장목록 불러오기 등으로 result만 먼저 오면 regex로 id를 맞춰야 목록 선택 UI가 맞음
    if (!allMods.length) return;

    const wantIds = [];
    const ignoreIds = [];
    for (const data of allMods) {
      if (result.wantMod.includes(data.regex)) wantIds.push(data.id);
      if (result.ignoreMod.includes(data.regex)) ignoreIds.push(data.id);
    }
    setSelected(wantIds);
    setIgnoreSelected(ignoreIds);
  }, [result, allMods]);

  // mode: 'want'면 오른쪽(원하는 맵모드), 'ignore'면 왼쪽(제외할 맵모드) 목록으로 배정.
  // 이미 반대쪽에 있던 항목을 클릭하면 그쪽에서 빠지고 클릭한 쪽으로 옮겨감.
  function clickHandler(mode, id, data) {
    const alreadyInTarget = mode === 'want' ? selected.includes(id) : ignoreSelected.includes(id);

    const nextSelected = selected.filter((item) => item !== id);
    const nextIgnoreSelected = ignoreSelected.filter((item) => item !== id);
    const nextResult = {
      ...result,
      wantMod: result.wantMod.filter((r) => r !== data.regex),
      ignoreMod: result.ignoreMod.filter((r) => r !== data.regex),
    };
    const nextEngResult = {
      ...engResult,
      wantMod: engResult.wantMod.filter((r) => r !== data.engRegex),
      ignoreMod: engResult.ignoreMod.filter((r) => r !== data.engRegex),
    };

    if (!alreadyInTarget) {
      if (mode === 'want') {
        nextSelected.push(id);
        nextResult.wantMod = [...nextResult.wantMod, data.regex];
        nextEngResult.wantMod = [...nextEngResult.wantMod, data.engRegex];
      } else {
        nextIgnoreSelected.push(id);
        nextResult.ignoreMod = [...nextResult.ignoreMod, data.regex];
        nextEngResult.ignoreMod = [...nextEngResult.ignoreMod, data.engRegex];
      }
    }

    setSelected(nextSelected);
    setIgnoreSelected(nextIgnoreSelected);
    setResult(nextResult);
    setEngResult(nextEngResult);
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <ModListBox
          title="제외할 맵모드"
          titleColor="error.main"
          lvOrder={[17, 1, 2, 3, 4, 5]}
          mapMod={allMods}
          searchWord={searchWord}
          selected={selected}
          ignoreSelected={ignoreSelected}
          onItemClick={(id, data) => clickHandler('ignore', id, data)}
          show17Mod={show17Mod}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <ModListBox
          title="원하는 맵모드"
          titleColor="success.main"
          lvOrder={[5, 4, 3, 2, 1, 17]}
          mapMod={allMods}
          searchWord={searchWord}
          selected={selected}
          ignoreSelected={ignoreSelected}
          onItemClick={(id, data) => clickHandler('want', id, data)}
          show17Mod={show17Mod}
        />
      </Grid>
    </Grid>
  );
}

export default MapModList;
